import axios from 'axios';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => {
        // token 无效，重新登陆
        if(res.data.status==501){
            localStorage.removeItem("userInfo")
            location.reload();
        }
        return res.data});
};

// 通用公用方法
const reqByJson = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json;charset=utf8',
            token: localStorage.getItem('logintoken')
        },
        data: JSON.stringify(params),
    }).then(res => res.data);
};

// 获取二进制流
const reqByBlob = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            token: localStorage.getItem('logintoken')
        },
        data: params,
        responseType: "arraybuffer",
        transformRequest: [
            function (data) {
               let ret = ''
               for (let it in data) {
                  ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
               }
               ret = ret.substring(0, ret.lastIndexOf('&'));
               return ret
            }
          ],
    });
};

export {
    loginreq,
    req,
    reqByJson,
    reqByBlob
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js